module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "SP",
    attrs: {
      "id": "ch3"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "DL"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_ch3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ZemkeHand"
  }, [_vm._v("September 3, 1948")])])]), _vm._v(" "), _c('p', {
    staticClass: "LTSA"
  }, [_c('span', {
    staticClass: "ZemkeHand"
  }, [_vm._v("Dear Hank Williams,")])]), _vm._v(" "), _c('p', {
    staticClass: "CO"
  }, [_vm._v("M"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("RS.")]), _vm._v(" K"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("IPLER’S BIG PLAN")]), _vm._v(" about getting Japanese pen pals for everyone didn’t seem to go like she’d hoped. Almost every kid came to class today with a different pen pal in mind. Everyone except Coolie Roberts and Theo Grace Thibodeaux, but they always forget their homework anyway. Mrs. Kipler looked like someone who didn’t get any cards in her Valentine box. I have to admit, when the kids shared their pen pals’ names, I could see why she was disappointed.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Verbia Calhoon picked her grandmother who lives in an old plantation home in Baton Rouge. Big deal! Most of the other kids selected their uncles, aunts, or cousins who live around Louisiana. The only person who picked someone out of state was Wallace Scott, who chose a cousin from Bay St. Louis, Mississippi.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("You could have heard a fly land on the windowsill when Wallace puffed out his chest and said, “My daddy said you’re a Red communist if you choose to write anyone from Japan.” He narrowed his eyes and stared around the class like he was daring someone to object.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("The room grew quiet except for the sound of a few nervous kids’ desks scraping against the floor.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Mrs. Kipler stared at Wallace. She said, “The war is over.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Wallace stared back. Nobody can do the staredown like Wallace. He didn’t blink once.")]), _vm._v(" "), _c('p', {
    staticClass: "TXS"
  }, [_vm._v("Finally Mrs. Kipler turned away and told us to get out our arithmetic books. None of my classmates selected anybody near as exciting as you, Hank Williams, someone who I believe will be very famous one day. I have a radar for good talent. You can bank on it.")]), _vm._v(" "), _c('p', {
    staticClass: "LTCL"
  }, [_c('span', {
    staticClass: "ZemkeHand"
  }, [_vm._v("Banking on the future of the sure-to-be-famous Hank Williams,")])]), _vm._v(" "), _c('p', {
    staticClass: "LTSIG-1"
  }, [_c('span', {
    staticClass: "ZemkeHand"
  }, [_vm._v("Tate P. Ellerbee")])]), _vm._v(" "), _c('div', {
    staticClass: "TOP-ONE"
  }, [_c('p', {
    staticClass: "LTPS"
  }, [_vm._v("PS—Please write back soon.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ba559e10","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter3.vue
// module id = 75
// module chunks = 0